import React from "react";
import { Link, Redirect } from "react-router-dom";
import Joi from "joi-browser";
import GoogleButton from 'react-google-button'
import Form from "./common/form";
import auth from "../services/authService";
import { toast } from "react-toastify";

class LoginForm extends Form {
  state = {
    data: { username: "", password: "" },
    errors: {}
  };

  schema = {
    username: Joi.string()
      .required()
      .label("Username"),
    password: Joi.string()
      .required()
      .min(5)
      .label("Password")
  };

  doSubmit = async () => {
    try {
      const { data } = this.state;
      await auth.login(data.username, data.password);

      const { state } = this.props.location;
      window.location = state ? state.from.pathname : "/";
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          const errors = { ...this.state.errors };
          errors.username = ex.response.data;
          this.setState({ errors });
        }
        else if (ex.response.status === 403 ||
          ex.response.status === 422) {
          toast.error(
            "Login failed. Please check your password."
          );
        }
      }
    }
  };

  render() {
    if (this.props.user) return <Redirect to="/" />;

    return (
      <div className="container">
        <div className="center_div">
        <h1>Login</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("username", "Username")}
          {this.renderInput(
            "password",
            "Password",
            "password",
            <Link className="text-rubyred" to="/forgot">
              <small><b>Forgot Password?</b></small>
            </Link>
            )}
          {this.renderButton("Login")}
        </form>

        <hr />
        <GoogleButton
          type="dark"
          onClick={() => { window.location.href = process.env.REACT_APP_BASE_URL + "login/google"; }} />
        </div>
      </div>
    );
  }
}

export default LoginForm;
